import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import StopCircle from "@mui/icons-material/StopCircle";
import "../../assets/styles/audio-question.css";
import { ResourceLinks } from "../../constants/";

export default function CorrectOrder({ audioText }) {
	const theme = useTheme();
	const [playing, setPlaying] = React.useState(false);
	let audioRef = React.useRef();

	const handlePlayAudio = () => {
		if (playing) {
			audioRef.pause();
			setPlaying(false);
			return;
		}
		audioRef.play();
		setPlaying(true);
		return;
		// const synth = window.speechSynthesis;
		// let voices = synth.getVoices();

		// const setVoice = () => {
		//   voices = synth.getVoices();
		//   const karenVoice = voices.find(
		//     (voice) => voice.name === "Karen" && voice.lang === "en-AU"
		//   );

		//   const speech = new SpeechSynthesisUtterance(text);
		//   speech.voice =
		//     karenVoice || voices.find((voice) => voice.lang === "en-AU");
		//   speech.onend = () => setPlaying(false);
		//   synth.speak(speech);
		//   setPlaying(true);
		// };

		// if (!voices.length) {
		//   synth.onvoiceschanged = setVoice;
		// } else {
		//   setVoice();
		// }
	};

	return (
		<React.Fragment>
			<Box
				sx={{
					mt: 2,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					cursor: "pointer",
				}}
				onClick={() => {
					handlePlayAudio();
				}}
			>
				<audio
                    style={{ display: "none" }}
					ref={(c) => (audioRef = c)}
					preload="auto"
					src={`${ResourceLinks.audio}${audioText}`}
					onEnded={() => setPlaying(false)}
				/>
				{!playing && (
					<PlayCircleIcon
						sx={{
							fontSize: "4rem",
							color: theme.palette.primary.main,
							zIndex: 1,
						}}
						className={playing ? "playing-animation" : ""}
					/>
				)}
				{playing && (
					<StopCircle
						sx={{
							fontSize: "4rem",
							color: theme.palette.primary.main,
							zIndex: 1,
						}}
					/>
				)}
				<Typography
					sx={{
						color: theme.palette.primary.main,
						fontWeight: "bold",
						backgroundColor: "white",
						padding: "0.5rem",
						borderRadius: "4px",
						ml: -2,
						pl: 2,
					}}
				>
					Play audio
				</Typography>
			</Box>
		</React.Fragment>
	);
}
